import React, { StrictMode } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Choghadiya from '../Choghadiya';

const App = () => {
  return (
    <StrictMode>
      <React.Fragment>
        <Router>
          <Routes>
            <Route path="/" element={<Choghadiya />} />
          </Routes>
        </Router>
      </React.Fragment>
    </StrictMode>
  );
};

export default App;
